export interface AvatarProps {
  /** Display name; the initial and the accessible name both derive from it. */
  name: string;
  size?: "small" | "medium";
  className?: string;
}

function initial(name: string): string {
  // Read a full code point, not `name[0]`: a display name may begin with an
  // astral character (an emoji, or CJK beyond the BMP) that indexing would halve.
  const codePoint = name.trim().codePointAt(0);
  return codePoint === undefined ? "?" : String.fromCodePoint(codePoint).toLocaleUpperCase();
}

/**
 * Identity mark. There is no uploaded-image path yet, so this is deliberately
 * a typographic monogram rather than an `<img>` with a placeholder.
 */
export function Avatar({ className, name, size = "medium" }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={["avatar", className].filter(Boolean).join(" ")}
      data-size={size}
    >
      {initial(name)}
    </span>
  );
}
